import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2394f571")

_pushScopeId("data-v-2394f571")
const _hoisted_1 = { class: "new-overlay-dialog" }
const _hoisted_2 = { class: "dialog-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "header" }, [
  /*#__PURE__*/_createVNode("span", null, " New Overlay ")
], -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "inline-attribute k-content" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Name", -1)
const _hoisted_7 = { class: "inline-attribute k-content" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Organization", -1)
const _hoisted_9 = { class: "inline-attribute k-content" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Event", -1)
const _hoisted_11 = { class: "multiselect" }
const _hoisted_12 = { class: "inline-attribute k-content" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Vehicle types", -1)
const _hoisted_14 = { style: {"flex":"1"} }
const _hoisted_15 = { ref: "vehicleTypesRef" }
const _hoisted_16 = { class: "inline-attribute k-content" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Day labels", -1)
const _hoisted_18 = { style: {"flex":"1"} }
const _hoisted_19 = { ref: "dayLabelsRef" }
const _hoisted_20 = { class: "inline-attribute k-content" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Osl", -1)
const _hoisted_22 = { style: {"flex":"1"} }
const _hoisted_23 = { ref: "oslRef" }
const _hoisted_24 = { class: "inline-attribute k-content" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Routing Service Version", -1)
const _hoisted_26 = { style: {"flex":"1"} }
const _hoisted_27 = { ref: "routingServiceVersionRef" }
const _hoisted_28 = { class: "inline-attribute k-content" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Comments", -1)
const _hoisted_30 = {
  key: 0,
  class: "inline-attribute k-content"
}
const _hoisted_31 = { class: "error" }
const _hoisted_32 = { class: "actions" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Save")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_calcite_input = _resolveComponent("calcite-input")
  const _component_calcite_button = _resolveComponent("calcite-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_calcite_input, { ref: "nameRef" }, null, 512)
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_calcite_input, {
            value: _ctx.overlay.Organisation,
            label: _ctx.overlay.OrganisationID,
            disabled: true,
            ref: "organizationRef"
          }, null, 8, ["value", "label"])
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_calcite_input, {
            value: _ctx.overlay.Event,
            label: _ctx.overlay.EventID,
            disabled: true,
            ref: "eventRef"
          }, null, 8, ["value", "label"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              _createVNode("select", _hoisted_15, null, 512)
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _createVNode("select", _hoisted_19, null, 512)
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode("div", _hoisted_22, [
              _createVNode("select", _hoisted_23, null, 512)
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode("div", _hoisted_26, [
              _createVNode("select", _hoisted_27, null, 512)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_28, [
          _hoisted_29,
          _createVNode(_component_calcite_input, {
            ref: "commentsRef",
            type: "textarea"
          }, null, 512)
        ]),
        (_ctx.isError == true)
          ? (_openBlock(), _createBlock("div", _hoisted_30, [
              _createVNode("span", _hoisted_31, _toDisplayString(_ctx.error), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_32, [
          _createVNode(_component_calcite_button, {
            color: "light",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.onClose())),
            title: "Close the modal",
            style: {"margin-right":"10px"}
          }, {
            default: _withId(() => [
              _hoisted_33
            ]),
            _: 1
          }),
          _createVNode(_component_calcite_button, {
            color: "blue",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.onSave())),
            title: "Save the overlay",
            loading: _ctx.saveOverlay,
            disabled: !_ctx.isInput || !_ctx.isSelect
          }, {
            default: _withId(() => [
              _hoisted_34
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ])
    ])
  ]))
})